(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-pd14-directory]:not([data-ready])').forEach(root => {
      const selector = root.querySelector('.pd14-selector');
      const families = [...root.querySelectorAll('[data-pd14-family]')];
      const buttons = [...root.querySelectorAll('[data-pd14-select]')];
      if (!selector || !families.length) return;
      const desktop = window.matchMedia('(min-width: 801px)');
      let selected = families[0];
      const sync = () => buttons.forEach(button => {
        const family = families.find(item => item.dataset.pd14Family === button.dataset.pd14Select);
        button.setAttribute('aria-expanded', String(family.open));
      });
      const select = family => {
        selected = family;
        families.forEach(item => { item.open = item === family; });
        sync();
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        select(families.find(family => family.dataset.pd14Family === button.dataset.pd14Select));
      }));
      families.forEach(family => family.addEventListener('toggle', () => {
        if (family.open) {
          selected = family;
          families.forEach(item => { if (item !== family) item.open = false; });
        }
        sync();
      }));
      const layout = () => {
        selector.hidden = !desktop.matches;
        if (desktop.matches) select(selected);
        else families.forEach(family => { family.open = false; });
        sync();
      };
      root.setAttribute('data-ready', 'true');
      layout();
      desktop.addEventListener('change', layout);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
